import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { fetchLiveBySourceRequest } from '../../../../redux/reports/clickHouse/clickHouseActions';
import type { OrderSource } from '../../../../redux/reports/clickHouse/clickHouseApi';
import type { LiveByChannelItem } from '../../../../interface/clickHouseInterface';

/**
 * ZAR-2371 — Source-view rows (`/sales/live/v2/by-channel?type=source`).
 *
 * READ-ONLY by design (SBS-03): Snapshot and Sales dispatch `fetchLiveBySourceRequest` right
 * next to every `fetchLiveByChannelRequest` (initial load, date/outlet/filter change, refresh),
 * so both views' data is already in Redux before anyone touches the toggle. Switching Channel ↔
 * Source therefore only swaps which rows the card renders — no request, no shimmer. The only
 * dispatch here is `retry`, for the Source view's own error state.
 */
export function useLiveBySource(params: {
    locationId: string;
    startDate?: string;
    endDate?: string;
    orderSource?: OrderSource;
}) {
    const dispatch = useAppDispatch();
    const { locationId, startDate, endDate, orderSource } = params;

    const items: LiveByChannelItem[] = useAppSelector((s) => s.clickHouse.liveBySourceSuccess);
    const loading: boolean = useAppSelector((s) => s.clickHouse.liveBySourceLoading);
    const error: boolean = useAppSelector((s) => s.clickHouse.liveBySourceFailure);
    const retry = () => dispatch(fetchLiveBySourceRequest({ locationId, startDate, endDate, orderSource }));

    return { items, loading, error, retry };
}
